import { BANNER_GRADIENT_STYLE, HOW_TO_WIN_HERO_BANNER_IMAGE_URL } from '@/components/HowToWin/helpers/constants';
import { BodyPrimary, H1 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

type Props = {
    variant: 'desktop' | 'mobile';
};

export const HowToWinHero = ({ variant }: Props) => {
    const { formatMessage } = useIntl();
    const isMobile = variant === 'mobile';
    const imageAlt = formatMessage({ id: 'howToWinRedesigned.hero.imageAlt' });
    const title = formatMessage({ id: 'howToWinRedesigned.hero.title' });
    const subtitle = formatMessage({ id: 'howToWinRedesigned.hero.subtitle' });

    const image = isMobile ? (
        <div className="relative aspect-[4/3] min-h-[120px] w-full">
            <img
                alt={imageAlt}
                className="absolute inset-0 h-full w-full object-contain"
                loading="lazy"
                src={HOW_TO_WIN_HERO_BANNER_IMAGE_URL}
            />
        </div>
    ) : (
        <img
            alt={imageAlt}
            className="w-full max-w-[620px]"
            loading="lazy"
            src={HOW_TO_WIN_HERO_BANNER_IMAGE_URL}
        />
    );

    const content = (
        <div
            className={cn('flex flex-col gap-xs', {
                'flex-1': !isMobile,
                'w-full text-left': isMobile,
            })}
        >
            <H1 className={isMobile ? 'text-text-primary' : undefined}>{title}</H1>
            <BodyPrimary className={isMobile ? 'text-text-primary' : undefined}>{subtitle}</BodyPrimary>
        </div>
    );

    return (
        <section
            className={cn('flex w-full flex-col items-center gap-md p-md', {
                'max-h-[312px] overflow-hidden rounded-container bg-primary-100': isMobile,
                'mx-auto mt-md max-w-[1596px] rounded-lg mdMin:flex-row mdMin:gap-xl mdMin:p-xl': !isMobile,
            })}
            data-testid={`howToWinHero-${variant}`}
            style={!isMobile ? BANNER_GRADIENT_STYLE : undefined}
        >
            {image}
            {content}
        </section>
    );
};
